import { DashboardCard } from "@tellescope/ui";
import { TellescopeModelFromName, useTellescopeInfiniteQuery } from "@tellescope/tanstack-query";
import { useTranslation } from "react-i18next";

export interface EligibilitySectionProps {
  contact: TellescopeModelFromName<"endusers">;
}

export const EligibilitySection = ({ contact }: EligibilitySectionProps) => {
  const { t } = useTranslation("contacts");
  const { data: eligibilityRecords } = useTellescopeInfiniteQuery({
    model: "enduser_eligibility_results",
    method: "getSome",
    request: {
      filter: {
        enduserId: contact.id,
      },
    },
    select: (data) => data.pages.flat(),
  });

  const showMessage = !eligibilityRecords?.length || !(contact.insurance || contact.insuranceSecondary);

  return (
    <div
      className={`flex-1 overflow-y-auto space-y-4 pr-2${
        showMessage ? "h-full flex items-center justify-center text-muted-foreground" : ""
      }`}
    >
      {contact.insurance || contact.insuranceSecondary
        ? eligibilityRecords?.length
          ? eligibilityRecords.map((result) => {
              // Determine status display based on result status
              const statusDisplay = result.statusText || result.status;
              const subtitle = result.type;
              const subtitleSecondary = result.results?.length
                ? `${result.results.filter((r) => r.is_covered).length} covered items`
                : statusDisplay;

              return (
                <DashboardCard
                  key={result.id}
                  statusLabel=""
                  title={result.title}
                  subtitle={subtitle}
                  subtitleSecondary={subtitleSecondary}
                  assignees={null}
                  dueDate=""
                  priority=""
                  timestamp={undefined}
                  className="w-full"
                />
              );
            })
          : t("No Eligibility Records for This Contact")
        : t("No Insurance Set for This Contact")}
    </div>
  );
};
